import "esbuild-css-modules-plugin-ns-css:src/index/components/schedule/schedule.module.css";

export default {
  "scheduleMetaInfo": "schedule-module__scheduleMetaInfo_mIncYW__100",
  "scheduletools": "schedule-module__scheduletools_mIncYW__100",
  "svg": "schedule-module__svg_mIncYW__100"
};
      